<div class="icon-nav">
  <ul>
    <!-- <li class="onhover-div mobile-search search-widgets" id="search-widgets">
      <div (click)="searchToggle()">
        <img src="assets/images/icon/search.png" class="img-fluid" alt="">
        <i class="ti-search"></i>
      </div>
      <div id="search-overlay" class="search-overlay" [ngStyle]="{'display': search ? 'block' : 'none' }">
        <div> 
            <span class="closebtn" title="Close Overlay" (click)="searchToggle()">×</span>
            <div class="overlay-content">
                <div class="container">
                    <div class="row">
                        <div class="col-xl-12">
                            <form>
                                <div class="form-group">
                                    <input type="text" class="form-control" id="exampleInputPassword1" placeholder="Search a Product">
                                </div>
                                <button type="submit" class="btn btn-primary"><i class="fa fa-search"></i></button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </li> -->
    <!-- <li class="onhover-div mobile-setting">
      <div><img src="assets/images/icon/setting.png" class="img-fluid" alt="settong">
        <i class="ti-settings"></i></div>
      <div class="show-div setting">
        <h6>language</h6>
        <ul>
          <li *ngFor="let language of languages">
            <a href="javascript:void(0)" (click)="changeLanguage(language.code)">{{ language.name }}</a>
          </li>
        </ul>
        <h6>currency</h6>
        <ul class="list-inline">
          <li *ngFor="let currency of currencies">
            <a href="javascript:void(0)" (click)="changeCurrency(currency)">{{ currency.name }}</a>
          </li>
        </ul>
      </div>
    </li> -->
    <li *ngIf="isOrderPage" class="onhover-div mobile-cart">
      <div>
        <a (click)="showBasket()">
          <!-- <img src="assets/images/icon/cart.png" class="img-fluid" alt=""> -->
          <mat-icon class="delivery-type-icon">shopping_cart</mat-icon>
          <!-- <i class="ti-shopping-cart"></i> -->
        </a>
      </div>
      <span class="cart_qty_cls">{{ products.length }}</span>
      <ul class="show-div show-div-visible shopping-cart" id="testtest2" *ngIf='!products.length'>
        <h5>No items added to order.</h5>
      </ul>
      <ul class="show-div show-div-visible shopping-cart" id="testtest" *ngIf='products.length'>
        <i class="fa fa-times checkout-close" aria-hidden="true" (click)="closeBasket()"></i>
        <li *ngFor="let product of products">
          <div class="media">
            <div class="media-body">
              <h4>{{ product?.title }}</h4>
              <h4 style="margin-bottom: 0px;">
                <span>
                  {{ product?.quantity }} x
                  {{ product?.price * productService?.Currency.price |
                  currency:productService?.Currency.currency:'symbol' }}
                </span>
              </h4>
              <h5 *ngIf="!!product?.extras && product.extras.length > 0">
                <span>
                  {{product?.extras[0].title}}
                </span>
              </h5>
            </div>
          </div>
          <div class="close-circle" (click)="removeItem(product)">
            <a href="javascript:void(0)"><i class="fa fa-times" aria-hidden="true"></i></a>
          </div>
        </li>
        <li>
          <div class="total">
            <h5>subtotal : <span>{{ getTotal | async | currency:productService?.Currency.currency:'symbol' }}</span>
            </h5>
          </div>
        </li>
        <li>
          <div class="buttons">
            <a [routerLink]="['/shop/cart']" class="view-cart">view cart</a>
            <a [routerLink]="['/shop/delivery-type']" class="checkout">checkout</a>
          </div>
        </li>
      </ul>
    </li>
    <li *ngIf="!isOrderPage" class="onhover-div mobile-cart">
      <div>
        <a (click)="showBasket()">
          <!-- <img src="assets/images/icon/cart.png" class="img-fluid" alt=""> -->
          <mat-icon class="delivery-type-icon">shopping_cart</mat-icon>
          <!-- <i class="ti-shopping-cart"></i> -->
        </a>
      </div>
      <span class="cart_qty_cls">{{ products.length }}</span>
      <ul class="show-div show-div-visible shopping-cart" id="testtest2" *ngIf='!products.length'>
        <h5>No items added to order.</h5>
      </ul>
      <ul class="show-div show-div-visible shopping-cart" id="testtest" *ngIf='products.length'>
        <i class="fa fa-times checkout-close" aria-hidden="true" (click)="closeBasket()"></i>
        <li *ngFor="let product of products">
          <div class="media">
            <div class="media-body">
              <h4>{{ product?.title }}</h4>
              <h4 style="margin-bottom: 0px;">
                <span>
                  {{ product?.quantity }} x
                  {{ product?.price * productService?.Currency.price |
                  currency:productService?.Currency.currency:'symbol' }}
                </span>
              </h4>
              <h5 *ngIf="!!product?.extras && product.extras.length > 0">
                <span>
                  {{product?.extras[0].title}}
                </span>
              </h5>
            </div>
          </div>
          <div class="close-circle" (click)="removeItem(product)">
            <a href="javascript:void(0)"><i class="fa fa-times" aria-hidden="true"></i></a>
          </div>
        </li>
        <li>
          <div class="total">
            <h5>subtotal : <span>{{ getTotal | async | currency:productService?.Currency.currency:'symbol' }}</span>
            </h5>
          </div>
        </li>
        <li>
          <div class="buttons">
            <a [routerLink]="['/shop/cart']" class="view-cart">view cart</a>
            <a [routerLink]="['/shop/delivery-type']" class="checkout">checkout</a>
          </div>
        </li>
      </ul>
    </li>
  </ul>
</div>